import { FilterShape } from '@/components/common/svg/shapes/FilterShape.tsx';

export const Filter = ({ onClick }: { onClick?: () => void }) => {
  return (
    <div
      className="filter-button"
      style={{
        backgroundColor: '#ffffff',
        position: 'absolute',
        top: '15px',
        right: '15px',
        zIndex: 3,
        borderRadius: '50%',
        width: '35px',
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
      }}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
    >
      <FilterShape width={18} height={18} />
    </div>
  );
};